import axios from "axios";

// Utils
import Constants from "Services/Utils/constants";

const getApiUrl = () => {
  switch (process.env.REACT_APP_KG_ULTRA_ENV) {
    case Constants.stage:
      return process.env.REACT_APP_KG_ULTRA_BASE_URL;
    case Constants.preproduction:
      return process.env.REACT_APP_KG_ULTRA_BASE_URL;
    case Constants.production:
      return process.env.REACT_APP_KG_ULTRA_BASE_URL;
    default:
      return "";
  }
};

function APIKit(isMultipart = false) {
  const SERVER_API = getApiUrl();
  const Kit = axios.create({
    baseURL: SERVER_API,
    timeout: 30000,
  });
  const responseHandler = (response) => {
    if (response.status === 401) {
      //force logout
    }
    return response;
  };

  const errorHandler = async (error) => {
    if (error?.response?.data?.status === 401) {
      localStorage?.setItem("isLoggedIn", null);
      localStorage?.setItem("userDetails", null);
      window.location.href = "/login";
    }

    if (error.response) {
      return error.response;
    } else {
      return error;
    }
  };

  Kit.interceptors.request.use(async function (config) {
    if (isMultipart) {
      config.headers["Content-Type"] = "multipart/form-data";
    }

    return config;
  });

  Kit.interceptors.request.use(async function (config) {
    if (isMultipart) {
      config.headers["Content-Type"] = "multipart/form-data";
    }
    const userDetails = JSON.parse(localStorage?.getItem("userDetails"));
    if (userDetails?.token) {
      config.headers["x-access-token"] = `${userDetails?.token}`;
    }
    return config;
  });

  Kit.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => errorHandler(error)
  );

  return Kit;
}

export default APIKit;
